import React from 'react';

type Props = {
  selectedCount: number;
  onClear: () => void;
  onAlterarComercial: () => void;
};

const CccBulkSelectionBar: React.FC<Props> = ({
  selectedCount,
  onClear,
  onAlterarComercial,
}) => {
  if (selectedCount <= 0) return null;

  return (
    <div className="ccc-bulk-selection-bar" role="status">
      <span className="ccc-bulk-selection-bar-count">
        {selectedCount === 1 ? '1 cliente selecionado' : `${selectedCount} clientes selecionados`}
      </span>
      <div className="ccc-bulk-selection-bar-actions">
        <button type="button" className="rec-btn rec-btn-ghost" onClick={onClear}>
          Limpar seleção
        </button>
        <button type="button" className="rec-btn rec-btn-primary" onClick={onAlterarComercial}>
          Alterar Comercial
        </button>
      </div>
    </div>
  );
};

export default CccBulkSelectionBar;
